var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBox2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_11109_1527)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 72,
    r: 32,
    fill: "url(#paint0_linear_11109_1527)",
    fillOpacity: 0.3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.0314 82.5096L65.6955 87.8455C65.5027 88.0395 65.3945 88.3018 65.3945 88.5753C65.3945 88.8487 65.5027 89.1111 65.6955 89.305L71.0314 94.6409C71.2246 94.8353 71.4871 94.9451 71.7612 94.9462C71.8977 94.9463 72.033 94.9194 72.1591 94.867C72.2853 94.8146 72.3998 94.7378 72.4961 94.6409L77.8268 89.305C78.0196 89.1111 78.1278 88.8487 78.1278 88.5753C78.1278 88.3018 78.0196 88.0395 77.8268 87.8455L72.4961 82.5096C72.3999 82.4134 72.2858 82.337 72.1601 82.285C72.0345 82.2329 71.8998 82.2061 71.7637 82.2061C71.6277 82.2061 71.493 82.2329 71.3674 82.285C71.2417 82.337 71.1275 82.4134 71.0314 82.5096ZM75.6324 88.5753L71.7663 92.4465L67.8951 88.5753L71.7663 84.704L75.6324 88.5753Z",
    fill: "url(#paint1_linear_11109_1527)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5089 72.0141H72.8071V58.1698C73.1745 58.1698 73.6093 58.2164 74.1061 58.2164C76.6938 58.2164 80.8342 57.6574 84.2396 54.6505C89.5238 49.9926 89.4151 44.2478 89.4151 44.0046C89.407 43.7355 89.2944 43.4801 89.1011 43.2926C88.9079 43.1052 88.6492 43.0004 88.38 43.0005C88.0591 43.0005 80.358 42.8712 75.3896 46.6234C71.6219 49.4491 70.8818 54.3555 70.7317 56.2549C70.7247 56.3324 70.7264 56.4106 70.7369 56.4878V60.0381C69.8694 58.4484 68.6732 57.0616 67.2279 55.9702C61.0174 51.3123 51.3859 51.4572 50.977 51.4676C50.7069 51.4675 50.4475 51.573 50.2541 51.7615C50.0607 51.9501 49.9487 52.2068 49.9419 52.4768C49.9419 52.777 49.8229 59.9036 56.4112 65.7156C59.609 68.463 63.7063 69.9369 67.9214 69.8559C68.8639 69.8469 69.8047 69.7725 70.7369 69.6334V72.0141H50.0351C49.7606 72.0141 49.4973 72.1232 49.3032 72.3173C49.1091 72.5114 49 72.7747 49 73.0492C49 73.3237 49.1091 73.587 49.3032 73.7811C49.4973 73.9752 49.7606 74.0843 50.0351 74.0843H70.7369V76.201C67.5434 76.4681 64.5768 77.959 62.4569 80.3623C60.3371 82.7655 59.2281 85.8951 59.3617 89.0969C59.4953 92.2987 60.8613 95.325 63.174 97.5432C65.4868 99.7615 68.5674 101 71.772 101C74.9766 101 78.0572 99.7615 80.3699 97.5432C82.6827 95.325 84.0486 92.2987 84.1822 89.0969C84.3159 85.8951 83.2069 82.7655 81.087 80.3623C78.9672 77.959 76.0005 76.4681 72.8071 76.201V74.0843H93.5089C93.7834 74.0843 94.0467 73.9752 94.2408 73.7811C94.4349 73.587 94.544 73.3237 94.544 73.0492C94.544 72.7747 94.4349 72.5114 94.2408 72.3173C94.0467 72.1232 93.7834 72.0141 93.5089 72.0141ZM76.668 48.2588C80.0527 45.7332 85.0781 45.2053 87.2983 45.1018C86.8377 48.212 85.2723 51.0524 82.8888 53.103C79.3851 56.2083 74.8048 56.2393 72.8899 56.0944C73.0503 54.3244 73.7749 50.4273 76.668 48.2588ZM57.7983 64.1474C54.6603 61.4336 52.6333 57.6579 52.1053 53.5429C54.7189 53.6413 61.4884 54.2364 65.9858 57.6108C69.8881 60.535 70.5868 65.5707 70.711 67.5373C68.558 67.8737 62.5234 68.3188 57.7983 64.1474ZM82.1229 88.5755C82.1229 90.6228 81.5158 92.624 80.3784 94.3262C79.2411 96.0284 77.6245 97.3551 75.7331 98.1385C73.8417 98.922 71.7605 99.1269 69.7526 98.7276C67.7447 98.3282 65.9004 97.3423 64.4528 95.8947C63.0052 94.4471 62.0194 92.6028 61.62 90.5949C61.2206 88.587 61.4256 86.5058 62.209 84.6144C62.9924 82.723 64.3191 81.1065 66.0213 79.9691C67.7235 78.8317 69.7248 78.2246 71.772 78.2246C74.5172 78.2246 77.15 79.3152 79.0912 81.2564C81.0323 83.1975 82.1229 85.8303 82.1229 88.5755Z",
    fill: "url(#paint2_linear_11109_1527)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_11109_1527",
    x: 0,
    y: 0,
    width: 144,
    height: 144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect1_foregroundBlur_11109_1527"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11109_1527",
    x1: 34.8685,
    y1: 52.5359,
    x2: 115.172,
    y2: 53.7333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA75F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6EE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11109_1527",
    x1: 64.3736,
    y1: 84.7015,
    x2: 80.3505,
    y2: 84.9396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA75F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6EE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11109_1527",
    x1: 45.3483,
    y1: 54.3606,
    x2: 102.499,
    y2: 55.0298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA75F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6EE6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox2);
export default __webpack_public_path__ + "static/media/box2.e9d74679a8306c2bc7e34a9882b4af91.svg";
export { ForwardRef as ReactComponent };